import {_Admin} from "./_Admin";
import {_User} from "./_User";

export const DisputesAPI = {
    Admin: _Admin,
    User: _User,
};